<div class="signin-wrap">
  <div class="signin-box">
    <ng-container *ngIf="!authServ.mode.firstPassSettingMode && !authServ.mode.forgotPassMode && !authServ.mode.inputCodeMode">
      <div class="signin-head text-center mb-3">
        <img class="logo" src="../../assets/images/logo_signin_smile9.png">
        <div class="mt-3"><small class="version text-muted ml-3">{{VERSION}}</small></div>
      </div>
    </ng-container>
    <div class="signin-body">
      <!-- 初期サインインフォーム -->
      <ng-container *ngIf="!authServ.mode.firstPassSettingMode && !authServ.mode.forgotPassMode && !authServ.mode.inputCodeMode">
        <label class="signin-label">{{labelSigninId}}</label>
        <input id="signinId" name="signinId" class="col-12 text-left" type="text"
              [formControl]="signinId"
              (change)="signinId.setValue(validationServ.toHalfWidthAlphameric(signinId.value))"
              (change)="signinId.setValue(utilServ.uSmile9.validateUsernameStyle(signinId.value))">

        <label class="signin-label">{{labelPassword}}</label>
        <div class="password-wrap mb-4">
          <input id="password" name="password" class="w-100 text-left"
                  [formControl]="password" [attr.type]="inputPasswordType"
                  (keyup.enter)="clickSignin()"
                  (change)="password.setValue(validationServ.toHalfWidthAlphameric(password.value))"
                  (change)="password.setValue(utilServ.uType.checkAndTrim(password.value))">
          <span class="eye-style" [ngSwitch]="inputPasswordType">
              <span *ngSwitchCase="'password'" class="oi oi-eye text-muted" (click)="inputPasswordType = 'text';"></span>
              <span *ngSwitchCase="'text'" class="oi oi-eye text-danger" (click)="inputPasswordType = 'password';"></span>
          </span>
        </div>

        <div *ngIf="authServ.isLoading" class="loading-area-sm">
          <app-loading [loadImgClass]="loadImgClass"></app-loading>
        </div>
        <button id="signin-btn" type="button" [class.d-none]="authServ.isLoading" class="col-12 text-center btn btn-primary"
                (click)="clickSignin()">
          サインイン
        </button>
        <div class="text-center mt-4">
            <a routerLink="/fsc-signin" (click)="forgotPassword()">パスワードをお忘れですか？</a>
        </div>
      </ng-container>

      <!-- 初回パスワード変更フォーム -->
      <ng-container *ngIf="authServ.mode.firstPassSettingMode">
        <p class="page-title mb-2">初回パスワード変更</p>
        <p>セキュリティ上、仮パスワードから<strong>新しいパスワードへの変更</strong>が必要です。お手数ですが、以下のフォームへ入力をお願い致します。</p>
        <p class="text-danger">パスワードは「8文字以上の大文字・小文字両方を含む半角英字と半角数字の組み合わせ」で設定をお願い致します。</p>
        <div class="row justify-content-center mt-3">
          <div class="col-12">
            <label class="signin-label">{{labelNewPass}}</label>
            <div class="password-wrap mb-4">
              <input id="newPass" name="newPass" class="w-100 text-left" [formControl]="newPass" [attr.type]="newPassType"
                      (keypress)="utilServ.uUI.moveNextFocus($event, 'newPass', getCurrentSeq())"/>
              <span class="eye-style">
                <span *ngIf="newPassType === 'password'" class="oi oi-eye text-muted" (click)="newPassType = 'text';"></span>
                <span *ngIf="newPassType === 'text'" class="oi oi-eye text-danger" (click)="newPassType = 'password';"></span>
              </span>
            </div>

            <label class="signin-label">{{labelNewPassConfirm}}</label>
            <div class="password-wrap mb-4">
              <input id="newPassConfirm" name="newPassConfirm" class="w-100 text-left"
                    [attr.type]="newPassConfirmType" [formControl]="newPassConfirm"
                    (keypress)="utilServ.uUI.moveNextFocus($event, 'newPassConfirm', getCurrentSeq())"
                    (change)="newPassConfirm.setValue(utilServ.uType.checkAndTrim(newPassConfirm.value))"/>
              <span class="eye-style">
                <span *ngIf="newPassConfirmType === 'password'" class="oi oi-eye text-muted" (click)="newPassConfirmType = 'text';"></span>
                <span *ngIf="newPassConfirmType === 'text'" class="oi oi-eye text-danger" (click)="newPassConfirmType = 'password';"></span>
              </span>
            </div>

            <button type="button" class="btn btn-primary btn-block mt-5" (click)="clickChangePassword()">パスワード変更</button>
          </div>
        </div>
      </ng-container>
      <!-- パスワード再設定フォーム1/2 -->
      <ng-container *ngIf="authServ.mode.forgotPassMode && !authServ.mode.inputCodeMode">
        <p class="page-title mb-2"><span class="badge badge-secondary mr-2">Step 1 / 2 </span>パスワード再設定</p>
        <p>パスワード再設定の為の<strong>「検証コード」</strong>をメールで送信します。再設定する{{labelSigninId}}を入力してください。</p>
        <a routerLink="/fsc-signin" (click)="changeInputCodeMode()">※検証コードを既にお持ちの方はこちら</a>
        <div class="row justify-content-center mt-3">
          <div class="col-12">
            <label class="signin-label">{{labelSigninId}}</label>
            <input id="signinId" name="signinId" type="text" class="col-12 text-left" [formControl]="signinId"
                    (keypress)="utilServ.uUI.moveNextFocus($event, 'signinId', getCurrentSeq())">
            <div *ngIf="authServ.isLoading" class="loading-area-sm">
              <app-loading [loadImgClass]="loadImgClass"></app-loading>
            </div>

            <button type="button" [class.d-none]="authServ.isLoading" class="btn btn-primary btn-block mt-5"
                    (click)="getCodeForSettingPassword()">検証コード発行
            </button>
            <button type="button" [class.d-none]="authServ.isLoading" class="btn btn-outline-secondary btn-block mt-4"
                    (click)="authServ.mode.forgotPassMode = false;">キャンセル
            </button>
          </div>

          <div class="col-sm-12 col-xs-12 mt-5 text-center">
            <small class="text-secondary">ご利用の環境によっては、メールが届くまでお時間を要する場合があります。予めご了承の程、お願い致します。</small>
          </div>
        </div>
      </ng-container>

      <!-- パスワード再設定フォーム2/2 -->
      <ng-container *ngIf="authServ.mode.inputCodeMode">
        <p class="page-title mb-2"><span class="badge badge-secondary mr-2">Step 2 / 2 </span>新しいパスワードの入力</p>
        <p>受信したメールに記載された<strong>「検証コード」</strong>と<strong>「新しいパスワード」</strong>を入力して下さい。</p>
        <div class="row justify-content-center mt-3">
          <div class="col-12">
            <label class="signin-label">{{labelCode}}</label>
            <input id="code" name="code" type="text" class="col-12 text-left" [formControl]="code"
                    (keypress)="utilServ.uUI.moveNextFocus($event, 'code', getCurrentSeq())">

            <label class="signin-label">{{labelSigninId}}</label>
            <input id="signinId" name="signinId" type="text" class="col-12 text-left" [formControl]="signinId"
                    (keypress)="utilServ.uUI.moveNextFocus($event, 'signinId', getCurrentSeq())">

            <label class="signin-label">{{labelNewPass}}</label>
            <div class="password-wrap">
              <input id="newPass" name="newPass" class="w-100 text-left" [attr.type]="newPassType" [formControl]="newPass"
                      (keypress)="utilServ.uUI.moveNextFocus($event, 'newPass', getCurrentSeq())"
                      (change)="newPass.setValue(utilServ.uType.checkAndTrim(newPass.value))"/>
              <span class="eye-style">
                <span *ngIf="newPassType === 'password'" class="oi oi-eye text-muted" (click)="newPassType = 'text';"></span>
                <span *ngIf="newPassType === 'text'" class="oi oi-eye text-danger" (click)="newPassType = 'password';"></span>
              </span>
            </div>

            <label class="signin-label">{{labelNewPassConfirm}}</label>
            <div class="password-wrap mb-4">
              <input id="newPassConfirm" name="newPassConfirm" class="w-100 text-left"
                      [attr.type]="newPassConfirmType" [formControl]="newPassConfirm"
                      (keypress)="utilServ.uUI.moveNextFocus($event, 'newPassConfirm', getCurrentSeq())"
                      (change)="newPassConfirm.setValue(utilServ.uType.checkAndTrim(newPassConfirm.value))"/>
              <span class="eye-style">
                <span *ngIf="newPassConfirmType === 'password'" class="oi oi-eye text-muted" (click)="newPassConfirmType = 'text';"></span>
                <span *ngIf="newPassConfirmType === 'text'" class="oi oi-eye text-danger" (click)="newPassConfirmType = 'password';"></span>
              </span>
            </div>

            <button type="button" class="btn btn-primary btn-block mt-5"
                    (click)="forgotPasswordSet()">パスワードを変更
            </button>
            <button type="button" class="btn btn-outline-secondary btn-block mt-4"
                    (click)="authServ.mode.inputCodeMode = false;">キャンセル
            </button>
          </div>
        </div>
      </ng-container>

    </div>
    <ng-container *ngIf="!authServ.mode.firstPassSettingMode && !authServ.mode.forgotPassMode && !authServ.mode.inputCodeMode">
      <div class="text-right text-muted mt-2 ml-3">
        <small>Powerd by S.K.S. Inc.</small>
      </div>
    </ng-container>
  </div>
</div>
